/**
 * Dose threshold alerts for frequent flyers
 * Future: @react-native-firebase/messaging for push notifications
 */

import { DEFAULT_ALERT_THRESHOLD_MICRO_SV } from '../constants';

export interface AlertCheckResult {
  shouldAlert: boolean;
  currentMicroSv: number;
  thresholdMicroSv: number;
}

/**
 * Check if annual dose exceeds user's alert threshold
 */
export function checkDoseThreshold(
  annualDoseMicroSv: number,
  thresholdMicroSv: number = DEFAULT_ALERT_THRESHOLD_MICRO_SV
): AlertCheckResult {
  return {
    shouldAlert: annualDoseMicroSv >= thresholdMicroSv,
    currentMicroSv: annualDoseMicroSv,
    thresholdMicroSv,
  };
}
